import * as THREE from 'three';
import Action from '../classes/Action';
import {GroupsManager} from '../classes/GroupsManager';
import Engine from '../classes/Engine';
import { CustomEventTypes } from '../globals';
import Scenario from '../classes/scenarioElements/Scenario';
import { Timeline } from '../classes/timeline/Timeline';
import {ActionDescription, ActionParameters} from "../classes/api/APIDecorators";
import {RegisterActionWithAPI} from "../classes/api/Decorators";

@ActionDescription("Removes an object group with the given guid")
@ActionParameters({groupGuid: "string"})
@RegisterActionWithAPI("RemoveGroupAction")
export default class RemoveGroupAction extends Action
{
	constructor(groupGuid: string)
	{
		const isGroupSelected = Engine.getInstance().getPickingManager().getCurrentSelection().groupGuid === groupGuid;
		const group = GroupsManager.getGroupByGuid(groupGuid);
		
		if(group)
		{
			const groupDatabase = new Map<string, THREE.Object3D[]>();

			for (const sceneGuid of group.sceneGuidToSceneObjects.keys())
			{
				groupDatabase.set(sceneGuid, []);
				const objects = group.sceneGuidToSceneObjects.get(sceneGuid)!;
				for (const object of objects)
				{
					groupDatabase.get(sceneGuid)!.push(object);
				}
			}
	
			let timelineToUpdate: Timeline | undefined;
			if (group.sceneGuidToTimelineObjects && group.sceneGuidToTimelineObjects.has(Scenario.currentStep()?.sceneId || ""))
			{
				timelineToUpdate = Scenario.currentStep()?.timeline;
			}
	
			super([groupGuid, isGroupSelected],
				[group!.name, groupGuid, groupDatabase, timelineToUpdate, isGroupSelected],
				"Removed Group " + group!.name,
				[groupGuid]);
		}
		else
		{
			super([groupGuid, isGroupSelected],	[groupGuid], "Removed Group " + groupGuid, [groupGuid]);
		}
		
	}

	do(groupGuid: string, isGroupSelected: boolean) : void
	{
		if (isGroupSelected)
		{
			Engine.getInstance().getPickingManager().clearSelection();
		}
		const groupName = GroupsManager.getGroupByGuid(groupGuid)!.name;
		GroupsManager.removeGroup(groupName);
	}

	undo(groupName: string, groupGuid: string, groupDatabase: Map<string, THREE.Object3D[]>, timelineToUpdate : Timeline, isGroupSelected: boolean) : void
	{
		if (timelineToUpdate) timelineToUpdate.resetAnimations();

		GroupsManager.createGroup(groupName, groupGuid);

		for (const [sceneGuid, objects] of groupDatabase)
		{
			GroupsManager.addToGroup(groupGuid, objects, sceneGuid);
		}

		if (isGroupSelected)
		{
			Engine.getInstance().getPickingManager().selectGroup(groupGuid);
			document.dispatchEvent(new CustomEvent(CustomEventTypes.objectSelectionChanged));
		}

		if (timelineToUpdate) timelineToUpdate.update();
	}

	verify(groupGuid : string) : boolean
	{
		return GroupsManager.getGroupByGuid(groupGuid) !== undefined;
	}
}
